import { RequestMethod } from '../types';

export function normalizeMethod(method: RequestMethod) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return method.toUpperCase() as RequestMethod;
}
